module.exports = __webpack_public_path__ + "img/2.d066d2ef.png";